export default __webpack_public_path__ + "static/exp2-34af9be2390c9757fc0bdeaec1117f4d.png";